import axios from "axios";
import { getAccessTokenHeader } from "../api/helper/getAccessTokenHeader";
import { getBackend } from "./getBackend";
import { handleError } from "./handleError";
import {
  SocialPlatform,
  PLATFORM_CONFIG,
} from "../components/PostDisplay/socialPlatforms";

export interface PublishParams {
  userId: string | null;
  postId: string | null;
  platform: SocialPlatform;
  postAs?: string | null;
}

export interface PublishResult {
  success: boolean;
  error?: string;
}

export const publishToSocialMedia = async ({
  userId,
  postId,
  platform,
  postAs,
}: PublishParams): Promise<PublishResult> => {
  try {
    if (!userId) {
      throw new Error("User ID is required");
    }

    if (!postId) {
      throw new Error("Post ID is required");
    }

    await axios.post(
      getBackend() + PLATFORM_CONFIG[platform].endpoint,
      {
        user_id: userId,
        post_id: postId,
        feed_slug: postAs,
      },
      {
        headers: await getAccessTokenHeader(),
      }
    );

    console.log(`Successful post to ${postAs || platform}!`);
    return { success: true };
  } catch (e) {
    handleError(e as Error);
    console.error(`Error posting to ${postAs || platform}`, e);
    return { success: false, error: (e as Error).message };
  }
};
